/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import {db} from "~/db/db";
import { ChevronRightIcon , CheckIcon} from "@chakra-ui/icons";
import MaskedInput from "react-text-mask";
import InputField from "~components/Form/components/InputField";
import ContainerForm from "~components/Form/components/ContainerForm";
import mask from "~services/utils/mask";
import prepareForOptions from "~services/utils/prepareForOptions";
import {
  editMaskCNPJCPF,
} from "~services/GlobalServices";
import StatusModal from "~components/Modal/ModalStatus";
import { initialPath } from "~misc/paths";
import { DeleteEdit, IconSuccess, WarningIcon } from "~misc/icons";
import useSelect from "~components/Form/hooks/useSelect";
import {
  useGetCliente,
  useGetClienteCarteira,
  useSalvarBuscaOnline,
} from "~pages/Wallet/hooks/useWallet";
import { set, get } from "idb-keyval";
import Select from "~components/Form/components/Select";
import useModalStatus from "~components/Modal/hooks/useModalStatus";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import Loader from "~components/Form/components/Loader";

import ModalResponse from "~components/Modal/ModalResponse";
import {
  /*classificacaoFiscalDefaultOptions,*/
  recebimentoDefaultOptions,
  setEmptyToSelectsOptions
} from "~services/utils/defaultOptions";
import useSender from "~pages/Wallet/Sender/hooks/useSender";
import { editMaskCEP, getTipoPessoa } from "../../../../../services/GlobalServices";
import { SaveIndexBD, getLocalStorage } from "~services/utils/SaveIndexBD";
import { useNavigate } from "react-router-dom";
import originControl from "~services/utils/originControl";
import AddressForm from "~components/Form/components/AddressForm";
import ValidateFormModal from "~components/Modal/ValidateFormModal";
import useTrilha from "~/fetchs/useTrilha";
import useGrupoCentralizador from "~/fetchs/useGrupoCentralizador";
import useGrupoSegmento from "~/fetchs/useGrupoSegmento";
import useSegmento from "~/fetchs/useSegmento";
import useAll from "~/fetchs/useAll";
import useUsuario from "~/fetchs/useUsuario";
import useParametros from "~fetchs/useParametros";
import useEquipeVenda from "~fetchs/useEquipeVenda";
import useEscritorioVenda from "~fetchs/useEscritorioVenda";
import ExcluirModal from "~pages/PricesTable/components/Modal/ExcluirModal";
import { replaceSpecialCharacters } from "~services/utils/formatText";
import Info from "~components/Form/components/Info";
import ModalDeclaracao from "~components/Modal/ModalDeclaracao";
import Modal from "~components/Modal/index";
import Tooltip from "~components/Geral/Tooltip";

const CreateEditForm = ({ itemClienteSelecionado, setLoadingProp }) => {
  const navigate = useNavigate();
  const { usuario } = useUsuario();
  const [opt, setOpt] = useState({});
  const [clienteSelecionado, setClienteSelecionado] = useState({});
  const { completeDate } = useSender();
  const newContato = {
    nome: "",
    sobrenome: "",
    cargo: "",
    email: "",
    telefone: "",
  };
  const [loading, setLoading] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [abrirModalDeclaracao, setAbrirModalDeclaracao] = useState(false);
  const [modalEnviada, setModalEnviada] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);
  const { isModalOpenStatus, closeModalStatus, openModalStatus } =
    useModalStatus();

  const {
    isModalOpen,
    closeModal,
    modalStatus,
    setMessageStatus,
    messageStatus,
    openModal,
    setSubmessageStatus,
    submessageStatus,
  } = useModalResponse();

  const {
    getOrigem,
    getPersistentParameters,
    setPersistentParameters,
    origens,
    parameters,
    persistentParameters
  } = originControl();

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

  const formikRef = useRef();

  const { onChangeTipoPessoa, tipoPessoaSelect, recebimentoSelect, onChangeRecebimento } = useAll(formikRef);


  const { formatNumber, cepMask } = mask();

  const {
    initialValues,
    setValue,
    valuess,
    cpfCnpj,
    setinitialValues
  } = useSender();

  const formStyle = {
    display: initialValues.id == 0 ? "none" : "block",
  };

  // Options
  const recebimentoOptions = recebimentoDefaultOptions;

  // States
  const [formValues, setFormValues] = useState({});
  const [localidade, setLocalidade] = useState("");
  const [idCliente, setIdCliente] = useState(0);
  const [enableFetchBuscaOnline, setEnableFetchBuscaOnline] = useState(false);
  const [clienteEmissorBuscaOnline, setClienteEmissorBuscaOnline] = useState(
    {}
  );

  //Requests
  // const carteiraRequest = useGetCarteiraClientes(0, 0);
  const clienteBuscaOnline = useGetClienteCarteira(idCliente, enableFetchBuscaOnline);
  const editFormSelect = true
  // IndexsDB
  const { optionsTrilha, trilha, onChangeTrilha, trilhaSelect, SetSelectTrilha, trilhasObjCodigo, trilhasObjNome } = useTrilha(formikRef);
 const { optionsEquipe, equipe, SetSelectEquipe, optionsEquipeedit, clearEquipe, onChangeEquipe, equipeSelect } = useEquipeVenda(formikRef, editFormSelect, clienteEmissorBuscaOnline);
  const { optionsEscritorio, escritorio, optionsEscritorioedit, SetSelectEscritorio, clearEscritorio, onChangeEscritorio, escritorioSelect } = useEscritorioVenda(formikRef,  equipeSelect, editFormSelect, clienteEmissorBuscaOnline);
  const { gruposCentralizadores, optionGruposCentralizadores, grupoCentralizadorSelect, onChangeGrupoCentralizador, SetSelectGrupoCentralizador } = useGrupoCentralizador(formikRef);
  const { optionsGrupoSegmento, grupoSegmento, grupoSegmentoSelect, onChangeGrupoSegmento, SetSelectGrupoSegmento } = useGrupoSegmento({ formikRef, trilha });
  const { optionsSegmento, segmentoSelect, onChangeSegmento, SetSelectSegmento } = useSegmento(grupoSegmento, formikRef);
  const { toObjectSlug } = useParametros();
  const grupoCentralizadorConstrutoraSelect = useSelect("grupoCentralizadorConstrutoraId");
  const grupoCentralizadorConstrutoraParam = toObjectSlug["grupos-centralizador-construtoras"];
  const grupoCentralizadorConstrutoraOptions = useMemo(() => {
    const filtrados = (gruposCentralizadores || []).filter((grupo) => grupo.trilhaId === trilha);
    return prepareForOptions(filtrados, ["codigo", "nome"], "id");
  }, [gruposCentralizadores, trilha]);
  const filteredGrupoCentralizador = useMemo(() => (gruposCentralizadores || []).filter((grupo) => grupo.trilhaId === trilha), [gruposCentralizadores, trilha]);
  const [grupoOptionsState, setGrupoOptionsState] = useState([]);
  const [grupoOptionsLoaded, setGrupoOptionsLoaded] = useState(false);
  const [selectedGrupoOption, setSelectedGrupoOption] = useState(null);
  const [grupoLoading, setGrupoLoading] = useState(true);

  const loadGrupoOptions = useCallback(() => {
    if ( grupoOptionsLoaded ) return;
    setGrupoLoading(true);
    setTimeout(() => {
      const opts = prepareForOptions(filteredGrupoCentralizador, ["codigo", "nome"], "id");
      setGrupoOptionsState(opts);
      setGrupoOptionsLoaded(true);
      setGrupoLoading(false);
    }, 50);
  }, [filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading]);
  const trilhasPermitidas = useMemo(() => {
    const raw = grupoCentralizadorConstrutoraParam?.valor || "";
    const codigos = raw
      .split(",")
      .map((codigo) => codigo.trim().toUpperCase())
      .filter(Boolean);
    return codigos
      .map((codigo) => trilhasObjCodigo?.[codigo]?.id || trilhasObjNome?.[codigo]?.id)
      .filter(Boolean);
  }, [grupoCentralizadorConstrutoraParam?.valor, trilhasObjCodigo, trilhasObjNome]);
  const isTrilhaPermitida = trilhasPermitidas.includes(trilha);
  const imoTrilhaId =
    trilhasObjNome?.IMO?.id || trilhasObjCodigo?.IMO?.id || trilhasObjCodigo?.["410"]?.id;
  const isTrilhaIMO = imoTrilhaId ? String(trilha) === String(imoTrilhaId) : false;
  const [carteira, setCarteiraData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const onChangeGrupoCentralizadorConstrutora = (e) => {
    const value = e?.value ?? null;
    grupoCentralizadorConstrutoraSelect.upDateValue(value || "");
    grupoCentralizadorConstrutoraSelect.upDateDefaultValue(e || "");
    formikRef.current?.setFieldValue("grupoCentralizadorConstrutoraId", value);
    setTimeout(() => formikRef.current?.setFieldTouched("grupoCentralizadorConstrutoraId", true));
  };

  useEffect(() => {
    const currentId = formikRef.current?.values?.grupoCentralizadorConstrutoraId;
    if (!currentId) {
      setSelectedGrupoOption(null);
      return;
    }

    if (grupoOptionsLoaded) {
      const match = grupoOptionsState.find((opt) => String(opt.value) === String(currentId));
      if (match) {
        setSelectedGrupoOption(match);
        return;
      }
    }

    const found = (gruposCentralizadores || []).find((g) => String(g.id) === String(currentId));
    if (found) setSelectedGrupoOption({ value: found.id, label: found.nome || found.codigo });
  }, [grupoOptionsLoaded, grupoOptionsState, gruposCentralizadores, initialValues]);

  useEffect(() => {
    if (!grupoOptionsLoaded && isTrilhaPermitida && filteredGrupoCentralizador && filteredGrupoCentralizador.length > 0) {
      loadGrupoOptions();
    }
  }, [isTrilhaPermitida, filteredGrupoCentralizador, grupoOptionsLoaded, grupoLoading, loadGrupoOptions]);

  const handleSubmit = async (values) => {
    if (!clienteEmissorBuscaOnline?.id) {
      openModal("alert");
      setMessageStatus("Selecione um cliente na busca para continuar!");
      return;
    }
    SaveIndexBD("form-new-emissor", initialValues);
    navigate(`${initialPath}/carteira/recebedor/novo?origem=${origens.busca_online}&pp=${persistentParameters}`);
  };

  //FunctionsIndexDB

  //useEffects
  useEffect(() => {
    if (Object.keys(initialValues).length > 0) {
      // formikRef.current.setFieldValue('classificacaoFiscal', initialValues?.classificacaoFiscal)
      const formatDate = (date) => new Date(date).toLocaleDateString("pt-BR");
      formikRef.current.setFieldValue( "duplaCategoriaVigencia", initialValues.validadeDe && initialValues.validadeAte
          ? `${formatDate(initialValues.validadeDe)} - ${formatDate(initialValues.validadeAte)}`
          : ""
      );

      formikRef.current.setFieldValue("duplaCategoriaElegivel", initialValues.duplaCategoria ? "Sim" : "Não");
      formikRef.current.setFieldValue("duplaCategoriaCondicao", initialValues?.condicao || "");
      formikRef.current.setFieldValue(
        "descargaCliente",
        initialValues?.descargaCliente
      );
      formikRef.current.setFieldValue(
        "descargaFumaca",
        initialValues?.descargaFumaca
      );

      SetSelectTrilha(initialValues?.trilhaId);
      SetSelectGrupoSegmento(initialValues?.grupoSegmentoId);
      SetSelectSegmento(initialValues?.segmentoId);
      SetSelectGrupoCentralizador(initialValues?.grupoCentralizadorId);
    }
  }, [initialValues.id]);

  useEffect(() => {
    if (!formikRef.current) return;

    if (!isTrilhaPermitida) {
      if (formikRef.current.values?.grupoCentralizadorConstrutoraId) {
        onChangeGrupoCentralizadorConstrutora(null);
      }
      return;
    }

    if (!grupoCentralizadorConstrutoraOptions?.length) return;

    const currentId = formikRef.current.values?.grupoCentralizadorConstrutoraId;
    if (currentId === null || currentId === undefined || currentId === "") return;

    const currentOption = grupoCentralizadorConstrutoraOptions.find(
      (opt) => String(opt.value) === String(currentId)
    );
    if (!currentOption) return;

    onChangeGrupoCentralizadorConstrutora(currentOption);
  }, [isTrilhaPermitida, grupoCentralizadorConstrutoraOptions, trilha]);

  const onSuccess = () => {
    setLoading(false);
    navigate(`${initialPath}/carteira/solicitacoes`);
  }

  const onError = () => {
    setLoading(false);
  }

  const buscaOnlineSalvar = useSalvarBuscaOnline(formValues, onSuccess, onError);

  useEffect(() => {
    if (Object.keys(formValues).length > 0) {
      buscaOnlineSalvar();
    }
  }, [formValues]);

  async function checkOrigem() {
    const pp = await getPersistentParameters();
    const origem = getOrigem();

    if (pp.includes(origens.conversao_prospect) || origem == origens.conversao_prospect) {
      checkProspect();
    }

    setPersistentParameters(pp.length > 0 ? pp.join(',') : "");
  }

  async function checkProspect() {
    const converterProspect = getLocalStorage("conversao-prospect", true);

    if (converterProspect) {
      setinitialValues({
        ...initialValues,
        conversao: converterProspect,
      });
    }
  }

  useEffect(() => {
    async function checkClienteSelecionado() {
      if (itemClienteSelecionado && itemClienteSelecionado.id) {
        setIdCliente(itemClienteSelecionado.id);
      }
    }
    checkClienteSelecionado();
  }, [itemClienteSelecionado]);

  useEffect(() => {
    if (idCliente > 0) {
      setEnableFetchBuscaOnline(true);
    }
  }, [idCliente]);

  useEffect(() => {
    if (clienteBuscaOnline.data) {
      setClienteEmissorBuscaOnline(clienteBuscaOnline.data);
    }
  }, [clienteBuscaOnline.data])

  const [controleTotal, setControleTotal] = useState(false);

  useEffect(() => {
    if (clienteEmissorBuscaOnline?.id) {
      const recebimento = clienteEmissorBuscaOnline?.formaRecebimentoNFE ? replaceSpecialCharacters(clienteEmissorBuscaOnline?.formaRecebimentoNFE).toLowerCase().replace(/-/g, "") : null;

      const optionTipoPessoa = (getTipoPessoa() || []).find(
        (tipoOpt) => tipoOpt.value === clienteEmissorBuscaOnline?.tipo
      );
      if (optionTipoPessoa) {
        tipoPessoaSelect.upDateDefaultValue(optionTipoPessoa);
      }

      if (recebimento) {
        const recebimentoOpt = (recebimentoOptions || []).find(item => item.value == recebimento);
        recebimentoSelect.upDateValue(recebimento);
        recebimentoSelect.upDateDefaultValue(recebimentoOpt || "");
        formikRef.current.setFieldValue("recebimento", recebimento);
        setTimeout(() => formikRef.current.setFieldTouched("recebimento", true));
      }

      setinitialValues({
        ...initialValues,
        trilhaId: clienteEmissorBuscaOnline?.trilhaId,
        razaoSocial: clienteEmissorBuscaOnline?.razaoSocial,
        // classificacaoFiscal: clienteEmissorBuscaOnline?.classificacaoFiscal,
        grupoCentralizadorId: clienteEmissorBuscaOnline?.grupoCentralizadorId,
        grupoSegmentoId: clienteEmissorBuscaOnline?.grupoSegmentoId,
        segmentoId: clienteEmissorBuscaOnline?.segmentoId,
        descargaCliente: clienteEmissorBuscaOnline?.descargaCliente,
        bairro: clienteEmissorBuscaOnline?.endereco?.bairro,
        cep: editMaskCEP(clienteEmissorBuscaOnline?.endereco?.cep),
        cidadeId: clienteEmissorBuscaOnline?.endereco?.cidadeId,
        codigoSAP: clienteEmissorBuscaOnline?.codigo,
        codigoVendedor: clienteEmissorBuscaOnline?.usuario?.codigo,
        nomeVendedor: clienteEmissorBuscaOnline?.usuario?.nome,
        complemento: clienteEmissorBuscaOnline?.endereco?.complemento,
        numero: clienteEmissorBuscaOnline?.endereco?.numero,
        rua: clienteEmissorBuscaOnline?.endereco?.rua,
        cidade: clienteEmissorBuscaOnline?.endereco?.cidade,
        descargaFumaca: clienteEmissorBuscaOnline?.descargaFumaca,
        id: clienteEmissorBuscaOnline?.id,
        celular: clienteEmissorBuscaOnline?.celular,
        codigo: clienteEmissorBuscaOnline?.codigo,
        dataNascimento: clienteEmissorBuscaOnline.dataNascimento ? clienteEmissorBuscaOnline.dataNascimento.split('T')[0].split('-').reverse().join('/') : "  ",
        diasAntecipacao: clienteEmissorBuscaOnline?.diasAntecipacao,
        documento: editMaskCNPJCPF(clienteEmissorBuscaOnline?.documento),
        email: clienteEmissorBuscaOnline?.email,
        idVendMais: clienteEmissorBuscaOnline?.idVendMais,
        inscricaoEstadual: clienteEmissorBuscaOnline?.inscricaoEstadual,
        inscricaoMunicipal: clienteEmissorBuscaOnline?.inscricaoMunicipal,
        nomeFantasia: clienteEmissorBuscaOnline?.nomeFantasia,
        recebimento: recebimento,
        telefone: clienteEmissorBuscaOnline?.telefone,
        tipo: clienteEmissorBuscaOnline?.tipo,
        usuarioId: clienteEmissorBuscaOnline?.usuarioId,
        paletizado: clienteEmissorBuscaOnline?.paletizado,
        equipeVendaId: clienteEmissorBuscaOnline?.equipeVendaId,
        escritorioVendaId: clienteEmissorBuscaOnline?.escritorioVendaId,
        grupoCentralizadorConstrutoraId: clienteEmissorBuscaOnline?.grupoCentralizadorConstrutoraId ?? null
      });

      setControleTotal(usuario?.codigo === clienteEmissorBuscaOnline?.usuario?.codigo)
    }
  }, [clienteEmissorBuscaOnline]);

  useEffect(() => {
    onChangeTrilha({ value: 2 });
    checkOrigem();
    // checkProspect();
  }, []);

  useEffect(() => {
    if (initialValues?.id)
      setLoadingProp(false);
  }, [initialValues?.id])

  if (!carteira || initialValues.id == 0) {
    <p>...Carregamento</p>;
  }

  const [removeBlock, setremoveBlock] = useState({
    arrayContatos: [],
    index: null,
  });
  const [indexBlock, setIndexBlock] = useState(null);

  function RemoveBlock() {
    removeBlock.arrayContatos[0].remove(removeBlock.index);
    setIsConfirmationOpen(false);
  }

  function HandleRemoveBlockClosed() {
    setIsConfirmationOpen(false);
  }

  const esconderCampos = !initialValues?.duplaCategoria ? "!hidden" : "!flex";
  const [declaracaoEnviada, setDeclaracaoEnviada] = useState(false);

  useEffect(() => {
    const verificarDeclaracao = async () => {
      if (!initialValues?.id) return;

      const registro = await db.duplaCategoria.get(Number(initialValues.id));

      setDeclaracaoEnviada(!!registro);
    };

    verificarDeclaracao();
  }, [initialValues?.id]);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={async (values) => {
        try {
          setLoading(true);
          await new Promise((resolve) => setTimeout(resolve, 4000));
          handleSubmit(values).then(() => {
            setLoading(false);
          });
        } finally {
          setLoading(false);
        }
      }}
    >
      {({ errors, touched, setFieldValue, setFieldTouched, values, isSubmitting }) => {

        const primeiroContatoCliente = values.contatos?.[0];

        const declaracaoModalData = {
          nome: primeiroContatoCliente?.nome ?? "",
          email: primeiroContatoCliente?.email ?? "",
          telefone: primeiroContatoCliente?.telefone ?? primeiroContatoCliente?.celular ?? "",
        };

        useEffect(() => {
          if (abrirModalDeclaracao) {
            const contato = values.contatos?.[0];

            setFieldValue("emailContato", contato?.email ?? "");
            setFieldValue("nomeContato", `${contato?.nome ?? ""} ${contato?.sobrenome ?? ""}`.trim());
            setFieldValue("telContato", contato?.telefone ?? contato?.celular ?? "");
          }
        }, [abrirModalDeclaracao]);

        return(
        <Form className="mt-[1rem] relative" id="prospect" style={formStyle}>
          <div
            className={loading ? "relative spinner__form-active" : "relative"}
          >
            <ContainerForm title="Dados Cadastrais">
              <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-4">
                <InputField
                  labelName="Código SAP:"
                  inputName="codigoSAP"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
                <InputField
                  labelName="Código Vendedor:"
                  inputName="codigoVendedor"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
                <InputField
                  labelName="Nome Vendedor:"
                  inputName="nomeVendedor"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
                <Select
                  name="tipo"
                  label="Tipo Pessoa:"
                  placeholder="Tipo Pessoa:"
                  options={[
                    {
                      value: 1,
                      label: "CPF - Pessoa Fisica",
                    },
                    {
                      value: 2,
                      label: "CNPJ - Pessoa Juridica",
                    },
                    // {
                    //   value: 3,
                    //   label: "CNOB - Obra de Pessoa Juridica",
                    // },
                    // {
                    //   value: 4,
                    //   label: "PNSD - Obra de Pessoa Fisica",
                    // },
                  ]}
                  onChange={(e) => {
                    onChangeTipoPessoa(e);
                  }}
                  errors={errors.tipo}
                  touched={touched.tipo}
                  {...tipoPessoaSelect}
                  isDisabled={true}
                />
              </div>
              <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-3">
                <InputField
                  labelName="CNPJ/CPF:"
                  inputName="documento"
                  as={MaskedInput}
                  mask={cpfCnpj}
                  inputMask="onmask"
                  inputType="text"
                  forceUppercase
                  isDisabled={true}
                />
                <InputField
                  labelName="Inscrição Municipal:"
                  inputName="inscricaoMunicipal"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
                <InputField
                  labelName="Inscrição Estadual:"
                  inputName="inscricaoEstadual"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
              </div>
              <div className="grid gap-x-2">
                <InputField
                  labelName="Razão Social:"
                  inputName="razaoSocial"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
              </div>
              <div
                className={`grid gap-x-2 md:grid-cols-1 ${values.tipo == 1 ? "lg:grid-cols-2" : "lg:grid-cols-1"
                  }`}
              >
                <InputField
                  labelName="Nome Fantasia:"
                  inputName="nomeFantasia"
                  inputMask="offmask"
                  inputType="text"
                  isDisabled={true}
                />
                {values.tipo == 1 ? (
                  <InputField
                    labelName="Data de Nascimento:"
                    inputName="dataNascimento"
                    as={MaskedInput}
                    mask={completeDate}
                    inputMask="onmask"
                    inputType="text"
                    isRequired={values.tipo == 1}
                    isDisabled={true}
                  />
                ) : null}
              </div>
              <AddressForm formikRef={formikRef} required={false} disabled={true} />
            </ContainerForm>

            <ContainerForm title="Dados pessoais">
              <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-2">
                <InputField
                  labelName="Email NF:"
                  inputName="email"
                  inputType="email"
                  inputMask="offmask"
                  isDisabled={!controleTotal}
                />
                <Select
                  name="recebimento"
                  label="Forma de Recebimento NFe:"
                  placeholder="Forma de Recebimento NFe:"
                  options={recebimentoOptions}
                  noOptionsMessage="Forma de Recebimento NFe não encontrada"
                  onChange={(e) => {
                    onChangeRecebimento(e);
                  }}
                  errors={errors.recebimento}
                  touched={touched.recebimento}
                  {...recebimentoSelect}
                  isDisabled={!controleTotal}
                />
                <InputField
                  labelName="Telefone de contato 1:"
                  inputName="telefone"
                  as={MaskedInput}
                  mask={formatNumber}
                  inputMask="onmask"
                  inputType="text"
                  isDisabled={!controleTotal}
                />
                <InputField
                  labelName="Telefone de contato 2:"
                  inputName="celular"
                  as={MaskedInput}
                  mask={formatNumber}
                  inputMask="onmask"
                  inputType="text"
                  isDisabled={!controleTotal}
                />
              </div>
            </ContainerForm>

            <ContainerForm title="Informações Adicionais">
              <div className="grid gap-x-4 grid-cols-2 lg:grid-cols-3">
                <Select
                  name="trilhaId"
                  label="Trilha Global:"
                  placeholder="Trilha Global:"
                  options={optionsTrilha}
                  noOptionsMessage="Trilha não encontrado"
                  onChange={(e) => {
                    onChangeTrilha(e);
                  }}
                  errors={errors.trilhaId}
                  touched={touched.trilhaId}
                  {...trilhaSelect}
                  isDisabled={true}
                />
                {/* <Select
                  name="classificacaoFiscal"
                  label="Classificação Fiscal:"
                  placeholder="Classificação Fiscal:"
                  options={classificacaoFiscalOptions}
                  noOptionsMessage="Classificação não encontrada"
                  onChange={(e) => onChangeClassificacaoFiscal(e)}
                  errors={errors.classificacaoFiscal}
                  touched={touched.classificacaoFiscal}
                  {...classificacaoFiscalSelect}
                  isDisabled={!controleTotal}
                /> */}
                <Select
                  name="grupoSegmentoId"
                  label="Grupo Segmento:"
                  placeholder="Grupo Segmento:"
                  options={optionsGrupoSegmento}
                  noOptionsMessage="Grupo não encontrado"
                  onChange={(e) => {
                    onChangeGrupoSegmento(e);
                  }}
                  errors={errors.grupoSegmentoId}
                  touched={touched.grupoSegmentoId}
                  {...grupoSegmentoSelect}
                  isDisabled={!controleTotal || !values.trilhaId}
                />
                <Select
                  name="segmentoId"
                  label="Segmento:"
                  placeholder="Segmento:"
                  options={optionsSegmento}
                  noOptionsMessage="Segmento não encontrado"
                  onChange={(e) => {
                    onChangeSegmento(e);
                  }}
                  errors={errors.segmentoId}
                  touched={touched.segmentoId}
                  {...segmentoSelect}
                  isDisabled={!controleTotal || !values.grupoSegmentoId}
                />
                <Select
                  name="grupoCentralizadorId"
                  label="Grupo Centralizador:"
                  placeholder="Grupo Centralizador:"
                  options={setEmptyToSelectsOptions(optionGruposCentralizadores)}
                  noOptionsMessage="Grupo não encontrado"
                  labelTooltip={
                    isTrilhaPermitida && (
                      <Info
                        bg="blue"
                        position="mobile-left"
                        text={
                          <>
                            Atualização do campo será feita após validação do <strong>GRUPO CENTRALIZADOR CONSTRUTORAS</strong>
                          </>
                        }
                        tooltipClass="w-4 h-4 relative mt-1"
                      />
                    )
                  }
                  onChange={(e) => {
                    onChangeGrupoCentralizador(e);
                  }}
                  errors={errors.grupoCentralizadorId}
                  touched={touched.grupoCentralizadorId}
                  {...grupoCentralizadorSelect}
                  isDisabled={true}
                />
                <Select
                  name="equipeVendaId"
                  label="Equipe de venda:"
                  placeholder="Equipe de venda:"
                  options={optionsEquipe}
                  noOptionsMessage="Equipe de venda não encontrada"
                  onChange={(e) => {
                    onChangeEquipe(e);
                  }}
                  errors={errors.equipeVendaId}
                  touched={touched.equipeVendaId}
                  {...equipeSelect}
                  isDisabled={!controleTotal}
                />
                <Select
                  name="escritorioVendaId"
                  label="Escritório de Venda:"
                  placeholder="Escritório de Venda:"
                  options={optionsEscritorio}
                  noOptionsMessage="Escritório de Venda não encontrado"
                  onChange={(e) => {
                    onChangeEscritorio(e);
                  }}
                  errors={errors.escritorioVendaId}
                  touched={touched.escritorioVendaId}
                  {...escritorioSelect}
                  isDisabled={!controleTotal}
                />
                {isTrilhaPermitida && (
                  <Select
                    name="grupoCentralizadorConstrutoraId"
                    label="Grupo Centralizador Construtoras:"
                    placeholder="Grupo Centralizador Construtoras:"
                    options={grupoOptionsLoaded ? grupoOptionsState : (selectedGrupoOption ? [selectedGrupoOption] : [])}
                    noOptionsMessage="Grupo Centralizador Construtoras não encontrado"
                    onChange={onChangeGrupoCentralizadorConstrutora}
                    errors={errors.grupoCentralizadorConstrutoraId}
                    touched={touched.grupoCentralizadorConstrutoraId}
                    {...grupoCentralizadorConstrutoraSelect}
                    loading={grupoLoading}
                    onMenuOpen={loadGrupoOptions}
                    isDisabled={grupoLoading || !controleTotal || !isTrilhaPermitida}
                  />
                )}
              </div>

              <div className="grid gap-x-4 mt-4 grid-cols-2 lg:grid-cols-3">
                <div>
                  <label className="flex items-center space-x-2">
                    <Field
                      type="checkbox"
                      name="descargaCliente"
                      className="h-5 w-5 rounded-lg text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 checked:bg-yellow-400 checked:border-transparent checked:text-blue-500 accent-terciaria"
                      disabled={!controleTotal}
                    />
                    <span className="text-gray-700">Descarga no Cliente</span>
                  </label>
                  {errors.descargaCliente && (
                    <p style={{ color: "red" }}>{errors.descargaCliente}</p>
                  )}
                </div>
              </div>

                <div className="mt-8">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-2 gap-y-1 items-start">
                    <h3 className="text-primaria text-2xl font-bold">Dupla Categoria</h3>
                    <Info
                      bg="blue"
                      text="Cliente com CNAEs de mais de uma classificação fiscal (Revenda, Consumidor Industrial ou Final)"
                    />
                  </div>
                  <div className="flex justify-between md:items-end items-start md:flex-row flex-col">
                    <div className="grid sm:grid-cols-7 grid-cols-2 gap-4 xl:w-1/2 lg:w-[65%] mt-4">
                      <InputField
                        customClasses="!font-semibold !uppercase !flex !justify-center !items-center"
                        labelName="Elegível"
                        inputName={`duplaCategoriaElegivel`}
                        inputMask="onmask"
                        inputType="text"
                        setFieldValue={setFieldValue}
                        isDisabled={true}
                        difference={true}
                      />

                      {
                        initialValues.validadeDe && initialValues.validadeAte && (
                          <div className={`col-span-3 ${esconderCampos}`}>
                            <InputField
                              customClasses={`!flex !justify-center !items-center`}
                              labelName="Vigência da declaração"
                              inputName={`duplaCategoriaVigencia`}
                              inputType="text"
                              setFieldValue={setFieldValue}
                              isDisabled={true}
                              difference={true}
                            />
                          </div>
                        )
                      }

                      <div className={`col-span-3 ${esconderCampos}`}>
                        <InputField
                          customClasses={`
                                          ${initialValues.condicao === "Dentro do prazo" ? "!bg-green-500"
                                          : initialValues.condicao === "Vencimento Próximo" ? "!bg-yellow-500"
                                          : initialValues.condicao === "Vencido" ? "!bg-red-500"
                                          : "!bg-gray-500"}
                                          !flex !justify-center !items-center  !text-white font-semibold`
                                        }
                          labelName="Status da declaração"
                          inputName={`duplaCategoriaCondicao`}
                          inputMask="onmask"
                          inputType="text"
                          setFieldValue={setFieldValue}
                          difference={true}
                          isDisabled={true}
                        />
                      </div>
                    </div>
                    {
                      initialValues.condicao !== "Dentro do prazo" && initialValues.duplaCategoria && (
                        <button
                          type="button"
                          onClick={() => declaracaoEnviada ? setModalEnviada(true) : setAbrirModalDeclaracao(true)}
                          className={` ${declaracaoEnviada ? "!bg-secundaria opacity-80" : "bg-primaria text-white opacity-100"} flex justify-between items-center gap-4 p-4 md:ml-4 md:mt-0 mt-2 rounded-lg font-bold button-search`}
                        >
                          {
                            !declaracaoEnviada ? (
                              <>
                                <span className="text-nowrap">Enviar Declaração</span>
                                <ChevronRightIcon />
                              </>
                            ) : (
                              <>
                                <span className="text-nowrap">Declaração enviada</span>
                                <CheckIcon className="!w-[10px] !h-[10px]" />
                              </>
                            )
                          }
                        </button>
                      )
                    }
                  </div>
                </div>

                  {initialValues?.areasVendaAmpliada?.length > 0 && (
                    <div className="mt-8">
                      <div className="flex flex-col sm:flex-row sm:items-center sm:gap-x-2 gap-y-1 items-start">
                      <h3 className="text-primaria text-2xl font-bold">Áreas de Venda Expandidas</h3>
                      <Tooltip />
                    </div>

                      <div className="space-y-1 max-w-[308px] mt-4">
                        {initialValues.areasVendaAmpliada.map((area, index) => (
                          <div
                            key={index}
                            className=" bg-[#D9D9D9] text-[#0A1D5D] text-sm font-bold uppercase px-4 py-1 rounded"
                          >
                            {area.setorAtividade?.descricao} ({area.grupoCliente?.descricao})
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
            </ContainerForm>

            {showSuccessMessage && (
              <div className="bg-secundaria relative mt-6 container">
                <div className="success-message-receiver py-6 text-center">
                  <p className="text-primaria text-2xl font-bold flex justify-center gap-x-4">
                    <IconSuccess />
                    Atualizado com sucesso!
                  </p>
                </div>
                <button
                  className="bg-secundaria p-4 rounded-lg text-primaria font-bold text-1xl absolute top-3 right-3 credit-button-solicitacao"
                  onClick={() => setShowSuccessMessage(false)}
                >
                  Fechar
                </button>
              </div>
            )}
          </div>

          {loading && (
            <>
              <div className="spinner__form ">
                <Loader />
              </div>
            </>
          )}

          <ValidateFormModal errors={errors} isSubmiting={isSubmitting} />

          <StatusModal
            isOpen={isModalOpenStatus}
            onClose={closeModalStatus}
            title="Cliente adicionado com sucesso!"
            buttonOne="Ok"
            buttonTwo={null}
            linkOne={`${initialPath}/carteira/solicitacoes`}
            linkTwo={null}
            isLinkRedirect={true}
          />
          <ExcluirModal
            isOpen={isConfirmationOpen}
            onClose={HandleRemoveBlockClosed}
            onConfirm={RemoveBlock}
            onCancel={HandleRemoveBlockClosed}
            mensagem={`Tem certeza de que deseja excluir o bloco ${indexBlock}`}
          />
          <ModalResponse
            isOpen={isModalOpen}
            closeModal={(e) => {
              if (modalStatus == "success")
                location.href = `${initialPath}/carteira/solicitacoes`;

              closeModal();
            }}
            status={modalStatus}
            message={messageStatus}
            submessage={submessageStatus}
            button="Ok"
          />
          {abrirModalDeclaracao && (
              <ModalDeclaracao
                isOpen={abrirModalDeclaracao}
                onClose={() => setAbrirModalDeclaracao(false)}
                initialValues={initialValues}
                setSuccessModal={setSuccessModal}
                setErrorModal={setErrorModal}
                contatoEmail={declaracaoModalData.email}
                contatoNome={declaracaoModalData.nome}
                contatoTelefone={declaracaoModalData.telefone}
              />
          )}
          <Modal
            isOpen={modalEnviada}
            onClose={() => setModalEnviada(false)}
            className="flex justify-center items-center flex-col"
            hideButtonOne={true}
            hideButtonTwo={true}
            title={
              <div className="flex items-center flex-col gap-y-4">
                <div className="flex items-center justify-center rounded-full bg-secundaria p-3">
                  <CheckIcon className="!w-[40px] !h-[40px] !text-primaria" />
                </div>
                <p>Declaração já enviada!</p>
              </div>
            }
            sub={
              <div className="max-w-[350px]">
                <p>Volte novamente em 5 dias para que possa solicitar uma nova declaração.</p>
              </div>
            }
          />
          <Modal
            isOpen={successModal}
            onClose={() => setSuccessModal(false)}
            className="flex justify-center items-center flex-col"
            hideButtonOne={true}
            hideButtonTwo={true}
            title={
              <div className="flex items-center flex-col gap-y-4">
                <div className="flex items-center justify-center rounded-full bg-secundaria p-3">
                  <CheckIcon className="!w-[40px] !h-[40px] !text-primaria" />
                </div>
                <p>Sua declaração foi enviada com sucesso!</p>
              </div>
            }
            sub={
              <div className="max-w-[350px]">
                <p>Em até 1 hora você receberá POR EMAIL um status sobre a solicitação.</p>
              </div>
            }
          />
          <Modal
            isOpen={errorModal}
            onClose={() => setErrorModal(false)}
            className="flex justify-center items-center flex-col"
            hideButtonOne={true}
            hideButtonTwo={true}
            title={
              <div className="flex items-center flex-col gap-y-4">
                <div className="flex items-center justify-center rounded-full bg-secundaria p-3">
                  <WarningIcon className="!w-[40px] !h-[40px] !text-primaria" />
                </div>
                <p>Houve um erro ao processar sua solicitação, por favor tente novamente</p>
              </div>
            }
          />
        </Form>
      )}}
    </Formik>
  );
};

export default CreateEditForm;
